<template>
  <div class="checkout">
    <div class="container">
      <ul class="breadcrumb">
          <li class="breadcrumb-item">
              <router-link :to="{name: 'Home'}">Página Principal</router-link>
          </li>
          <li class="breadcrumb-item">
              <span>Pagamento</span>
          </li>
      </ul>
      <div class="element-wrapper pb-2">
        <h3>Pagamento</h3>
      </div>      
      <div class="element-box">
        <div class="row">
          <div class="col-md-8 col-sm-12">
            <div class="row" >
              <div class="col-12">
                <div class="element-wrapper" v-if="user.cartao">
                  <h6 class="element-header">
                    Detalhes do titular
                  </h6>
                  <div class="row">
                    <div class="col">
                      <div class="label">Nome Titular</div>
                      <h6>{{user.name}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">E-mail</div>
                      <h6>{{user.email}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Nº Dr.Achei Card</div>
                      <h6>{{user.cartao.numeroCartao}}</h6>
                    </div>
                  </div>
                </div>
                <div class="element-wrapper" v-if="dependentes && dependentes.length > 0">
                  <h6 class="element-header">Atendimento Para</h6>
                  <div class="row">
                    <div class="col">
                      <div class="label"></div>
                      <select class="form-control form-control-md bright"
                        name="dependente" id="dependente" v-model="dependente">
                        <option :value="null">Titular</option>
                        <option v-for="(dependente, i) in dependentes" :key="dependente.cpf" 
                          :value="dependente">Dependente {{i + 1}}: <b>{{dependente.name || dependente.NomeDepedente}}</b></option>
                      </select>
                    </div>
                  </div>
                </div>
                <br>
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Tipo de Pagamento Selecionado
                  </h6>
                <div class="row">
                  <div class="col-md-5 col-sm-12" v-if="pedido.tipoPagamento === 'Drachei'">
                    <a class="post-box bg-light" href="#">
                      <div class="post-media"><img src="@/img/brand-drachei-vert.svg" class="img-fluid" alt="Brand"></div>
                      <div class="post-content">
                        <h6 class="post-title">
                          {{ valorDrAchei | money }}
                        </h6>
                        <div class="post-foot">
                          
                          <a class="post-link" href="#"><span>Selecionar</span><i class="os-icon os-icon-arrow-right7"></i></a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-5 col-sm-12" v-if="pedido.tipoPagamento === 'SinSaude'">
                    <a class="post-box bg-light" href="#">
                      <div class="post-media">
                        <img src="@/img/drachei-card.png" alt="Dr.AcheiCard" class="img-fluid mt-3">
                      </div>
                      <div class="post-content">
                        <h6 class="post-title">
                          {{ valorSinSaude | money }}
                        </h6>
                        <div class="post-foot">
                          <a class="post-link" href="#"><span>Selecionar</span><i class="os-icon os-icon-arrow-right7"></i></a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Dados de Pagamento
                  </h6>
                  <div class="os-tabs-w" v-if="rede && !rede.pagamentoOnline">
                    <div class="os-tabs-controls">
                      <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item" v-if="user.cartao">
                          <a class="nav-link" data-toggle="tab" href="#tab_local_">
                            <i class="os-icon os-icon-wallet-loaded"></i>
                            <p>Pagamento no local</p>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane active show" id="tab_local_">
                        <form @submit.prevent="payment(true)">
                          <div class="form-buttons-w">
                              <button class="btn btn-primary btn-lg" type="submit"> Gerar Voucher de Atendimento</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div v-else class="os-tabs-w">
                    <div class="os-tabs-controls">
                      <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item">
                          <a class="nav-link active show" @click="paymentMethod = 'cartao'" data-toggle="tab" href="#tab_credit">
                            <i class="far fa-credit-card"></i>
                            <p>Cartão de crédito</p>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" @click="paymentMethod = 'boleto'" data-toggle="tab" href="#tab_boleto">
                            <i class="fas fa-barcode"></i>
                            <p>Boleto</p></a>
                        </li>
                        <li class="nav-item" v-if="user.cartao">
                          <a class="nav-link" @click="paymentMethod = ''" data-toggle="tab" href="#tab_local">
                            <i class="os-icon os-icon-wallet-loaded"></i>
                            <p>Pagamento no local</p>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane active show" id="tab_credit">
                        <form @submit.prevent="pagarComCredito">
                          <div class="form-desc">
                            <i class="fas fa-lock"></i> Compra Segura
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Número do Cartão</label>
                            <div class="col-sm-8">
                              <img :src="bandeira" alt="bandeira-cartao" height="50"><input v-model="card.card_number" class="form-control form-control-lg" placeholder="Digite apenas os números" type="tel" v-card v-mask="'#### #### #### ####'" required>
                              <small>Sem pontos, espaços e hífens</small>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Nome impresso no cartão</label>
                            <div class="col-sm-8">
                              <input v-model="card.holder_name" class="form-control" placeholder="Digite o nome" type="text" required>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for="">Validade</label>
                            <div class="col-md-4 col-6">
                              <input class="form-control" placeholder="Mês com 2 dígitos. Ex. 03" type="tel" v-model="card.expiration_month" minlength="2" maxlength="2" size="4" v-mask="'##'" required>
                            </div>
                            <div class="col-md-4 col-6">
                              <input class="form-control" placeholder="Ano com 4 dígitos. Ex. 2019" type="tel" v-model="card.expiration_year" minlength="4" maxlength="4" size="4" v-mask="'####'" required>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Código de Segurança</label>
                            <div class="col-sm-8">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" id="validationTooltipUsernamePrepend"><a href="#"><i class="far fa-question-circle"></i></a></span>
                                </div>
                                <input v-model="card.security_code" type="tel" class="form-control" id="validationTooltipUsername" aria-describedby="validationTooltipUsernamePrepend" required minlength="3" maxlength="3" placeholder="Com 3 dígitos. Ex. 123">
                                <div class="invalid-tooltip">
                                  Please choose a unique and valid username.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group row" v-if="parcelas.length">
                            <label class="col-form-label col-sm-4 text-right" for="">Parcelas</label>
                            <div class="col-sm-3">
                              <select name="" id="" class="form-control" v-model="installment_plan.number_installments">
                                <option :value="1">Á Vista</option>
                                <option v-for="parcela in parcelas" :key="parcela.value" :value="parcela.value" v-text="parcela.text"></option>
                              </select>
                            </div>
                          </div>
                          <div class="form-buttons-w">
                            <button class="btn btn-primary btn-lg" type="submit"> Finalizar Compra</button>
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" id="tab_boleto">
  
                        <div class="content-box">
                          <div class="row">
                          <div class="col-md-4 col-sm-12"><h5 class="text-center">Imprima o boleto e pague no banco</h5></div>
                          <div class="col-md-4 col-sm-12"><h5 class="text-center">Ou pague pela internet usando o codigo de barras</h5></div>
                          <div class="col-md-4 col-sm-12"><h5 class="text-center">ATENÇÃO:Após pagamento,o boleto será compensado em até 4 dias úteis.</h5></div>
                        </div>
                        </div>
                        <div class="row">
                          <div class="sm-12 col-md-4">
                            <label>Dia para Pagamento</label>
                            <select class="form-control" v-model="dia_pagamento">
                              <option :value="5">5</option>
                              <option :value="10">10</option>
                              <option :value="15">15</option>
                              <option :value="20">20</option>
                              <option :value="25">25</option>
                              <option :value="30">30</option>
                            </select>
                          </div>
                          <div class="col col-sm-12">
                            <button class="btn btn-primary btn-lg block mt-1" type="button" @click="pagarComBoleto"> Pagar com Boleto</button>
                          </div>
                        </div>
                        <br>
                        <div class="content-box">
                          <label for="">Importante</label>
                          <ul>
                            <li>Caso o seu computador tenha um programa anti pop-up, será preciso desativá-lo antes de finalizar sua compra e imprimir o boleto ou pagar pelo internet banking;</li>
                            <li>Imprima-o e pague-o no banco ou pela internet;</li>
                            <li>ATENÇÃO:Após pagamento,o boleto será compensado em até 4 dias úteis.</li>
                            <li>Os serviços comprados por boleto só poderão ser utilizados após 4 dias úteis da compra.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="tab-pane" id="tab_local">
                        <form @submit.prevent="payment">
                          <div class="alert alert-warning" role="alert">
                            <strong>Atenção! </strong>Válido apenas para clientes Dr.Achei Card.
                          </div>
                          <div class="form-buttons-w">
                              <button :disabled="pedido.tipoPagamento === 'DrAchei' || (rede && !rede.pagamentoUnidade)" class="btn btn-primary btn-lg" type="submit"> Gerar Voucher de Atendimento</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
        
            </div>
          </div>
          <div class="col-md-3 col-sm-12 offset-md-1">
            <div class="element-wrapper sticky">
                <h6 class="element-header">
                  Resumo da Compra
                </h6>
                <table class="table table-clean">
                  <tbody>
                    <tr v-if="isConsulta">
                      <td>
                        <div class="value">
                          Consulta
                        </div>
                        <span class="sub-value">{{consulta.especialidade.nome}}</span>
                      </td>
                      <td class="text-right">
                        <div class="value">
                          {{consulta.valorParticular | money}}
                        </div>
                      </td>
                    </tr>
                    <tr v-if="isExame"
                      v-for="exame in exames" :key="exame._id">
                      <td>
                        <div class="value">
                          Exame
                        </div>
                        <span class="sub-value">{{exame.nomeExame}}</span>
                      </td>
                      <td class="text-right">
                        <div class="value">
                          {{getValor(exame) | money}}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="value">
                          Sub-Total
                        </div>
                        
                      </td>
                      <td class="text-right">
                        <div class="value">
                          {{(isConsulta ? valorConsulta : subTotalParticular) | money}}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="value">
                          Desconto
                        </div>
                        <span class="sub-value">{{pedido.tipoPagamento}}</span>
                      </td>
                      <td class="text-right">
                        <div class="value text-success">
                          -{{(isConsulta ? valorDescontoConsulta : valorDescontoExame) | money}}
                        </div>
                      </td>
                    </tr>
                    <tr v-if="pedido.cupom">
                      <td>
                          <div class="value text-success">
                            CUPOM
                          </div>
                          <span class="sub-value">{{pedido.cupom.name}}</span>
                        </td>
                        <td class="text-right">
                          <div class="value text-success">
                            -{{(pedido.cupom.descontoCliente) | money}}
                          </div>
                        </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="value">
                          <h6>Total</h6>
                        </div>
                        
                      </td>
                      <td class="text-right">
                        <div class="value">
                          <h6>{{isConsulta ? valorConsulta : totalExame | money}}</h6>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" v-if="!pedido.cupom">
                        <div class="form-group" :class="{'has-danger': errors.has('cupom')}">
                          <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Cupom Desconto" 
                              aria-label="Cupom desconto" aria-describedby="basic-addon2"
                              name="cupom" id="cupom"
                              v-model.trim="cupom" v-validate="'required'">
                            <div class="input-group-append">
                              <button class="btn btn-primary" type="button" @click="aplicarCupom">Aplicar</button>
                            </div>
                          </div>
                          <div v-if="errors.has('cupom')" class="help-block form-text text-muted form-control-feedback">
                            {{errors.first('cupom')}}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as http from 'axios'

const tabelaJurosZoop = {
  '1x': 1.0,
  '2x': 1.0,
  '3x': 1.0,
  '4x': 6.59,
  '5x': 7.43,
  '6x': 8.28,
  '7x': 9.40,
  '8x': 10.27,
  '9x': 11.14,
  '10x': 12.03
}

export default {
  async created () {
    const id = this.$route.query.id
    this.loadPedido(id)
    const cartaoResponse = await http.get(`/cartao/id/${this.user.cartao._id}`)
    const responseClient = await http.get(`/clients/${cartaoResponse.data.pedido.client._id}`)
    this.dependentes = responseClient.data.dependentes
  },
  data () {
    return {
      paymentMethod: 'cartao',
      bandeira: require('@/assets/images/cartao_vazio.png'),
      loading: false,
      selectedPlan: null,
      selectedPurchase: null,
      isParcelado: false,
      qtdParcelas: null,
      subTotalParticular: 0,
      subTotalDrAchei: 0,
      subTotalSinSaude: 0,
      dia_pagamento: 5,
      customer: {
        first_name: '',
        last_name: '',
        taxpayer_id: '',
        description: '',
        email: ''
      },
      card: {
        holder_name: '',
        expiration_month: '',
        expiration_year: '',
        security_code: '',
        card_number: ''
      },
      installment_plan: {
        number_installments: 1
      },
      pedido: {},
      nrCupomDesconto: null,
      cupom: null,
      dependente: null,
      dependentes: []
    }
  },

  computed: {
    validationsCustomer () {
      return {
        first_name: !!this.customer.first_name,
        last_name: !!this.customer.last_name,
        taxpayer_id: !!this.customer.taxpayer_id,
        description: !!this.customer.description,
        email: !!this.customer.email
      }
    },

    isCustomerValid () {
      const validations = this.validationsCustomer
      return Object.keys(validations).every(key => validations[key])
    },

    validationsCard () {
      return {
        holder_name: !!this.card.holder_name,
        expiration_month: !!this.card.expiration_month && this.card.expiration_month.length === 2,
        expiration_year: !!this.card.expiration_year && this.card.expiration_year.length === 4,
        security_code: !!this.card.security_code && this.card.security_code.length === 3,
        card_number: !!this.card.card_number
      }
    },

    isCardValid () {
      const validations = this.validationsCard
      return Object.keys(validations).every(key => validations[key])
    },

    rede () {
      return this.pedido.unidade
    },

    user () {
      return this.$store.getters.user
    },

    isConsulta () {
      return this.pedido && this.pedido.consulta
    },

    isExame () {
      return this.pedido && this.pedido.exames && this.pedido.exames.length > 0
    },

    consulta () {
      return this.pedido ? this.pedido.consulta : {}
    },

    exames () {
      return this.pedido ? this.pedido.exames : []
    },

    valorDrAchei () {
      let total = 0

      if (this.isConsulta) {
        total = this.valorConsulta
      } else {
        total = this.subTotalDrAchei
      }

      if (this.pedido.cupom) {
        total -= this.pedido.cupom.descontoCliente
      }

      return total
    },

    valorSinSaude () {
      let total = 0

      if (this.isConsulta) {
        total = this.valorConsulta
      } else {
        total = this.subTotalSinSaude
      }

      return total
    },

    subTotalExameTipoPagamento () {
      let total = 0

      if (this.pedido.tipoPagamento === 'Drachei') {
        total = this.subTotalDrAchei
      } else {
        total = this.subTotalSinSaude
      }

      return total
    },

    totalExame () {
      let total = this.subTotalExameTipoPagamento
      if (this.pedido.cupom) {
        total -= this.pedido.cupom.descontoCliente
      }
      return total
    },

    valorConsulta () {
      let total = 0

      if (!this.isConsulta) {
        total = 0
      } else if (!this.pedido) {
        total = 0
      } else if (this.pedido.tipoPagamento === 'Drachei') {
        total = this.consulta.valorDrAchei
      } else if (this.pedido.tipoPagamento === 'SinSaude') {
        total = this.consulta.valorSinSaude
      }

      if (this.pedido.cupom) {
        total -= this.pedido.cupom.descontoCliente
      }

      return total
    },

    valorDescontoConsulta () {
      let total = 0

      if (!this.isConsulta) {
        total = 0
      } else {
        total = this.consulta.valorParticular - this.valorConsulta
        if (this.pedido.cupom) {
          total += this.pedido.cupom.descontoCliente
        }
      }

      return total
    },

    valorDescontoExame () {
      let total = 0
      total = this.subTotalParticular - this.subTotalExameTipoPagamento
      return total
    },

    parcelas () {
      let total = 0
      let parcelas = []

      if (this.isConsulta && this.valorConsulta > 200) {
        total = this.valorConsulta
      } else if (!this.isConsulta && this.subTotalExameTipoPagamento > 200) {
        total = this.subTotalExameTipoPagamento
      }

      if (total > 0) {
        const valorParcela2x = (Math.floor(100 * (total / 2)) / 100).toFixed(2)
        const valorParcela3x = (Math.floor(100 * (total / 3)) / 100).toFixed(2)
        const valorParcela4x = (Math.floor(100 * ((((total * tabelaJurosZoop['4x']) / 100) + total) / 4)) / 100).toFixed(2)
        const valorParcela5x = (Math.floor(100 * ((((total * tabelaJurosZoop['5x']) / 100) + total) / 5)) / 100).toFixed(2)
        const valorParcela6x = (Math.floor(100 * ((((total * tabelaJurosZoop['6x']) / 100) + total) / 6)) / 100).toFixed(2)
        const valorParcela7x = (Math.floor(100 * ((((total * tabelaJurosZoop['7x']) / 100) + total) / 7)) / 100).toFixed(2)
        const valorParcela8x = (Math.floor(100 * ((((total * tabelaJurosZoop['8x']) / 100) + total) / 8)) / 100).toFixed(2)
        const valorParcela9x = (Math.floor(100 * ((((total * tabelaJurosZoop['9x']) / 100) + total) / 9)) / 100).toFixed(2)
        const valorParcela10x = (Math.floor(100 * ((((total * tabelaJurosZoop['10x']) / 100) + total) / 10)) / 100).toFixed(2)
        parcelas.push({ value: 2, text: `2x de R$ ${valorParcela2x}`, currency: valorParcela2x })
        parcelas.push({ value: 3, text: `3x de R$ ${valorParcela3x}`, currency: valorParcela3x })
        parcelas.push({ value: 4, text: `4x de R$ ${valorParcela4x}`, currency: valorParcela4x })
        parcelas.push({ value: 5, text: `5x de R$ ${valorParcela5x}`, currency: valorParcela5x })
        parcelas.push({ value: 6, text: `6x de R$ ${valorParcela6x}`, currency: valorParcela6x })
        parcelas.push({ value: 7, text: `7x de R$ ${valorParcela7x}`, currency: valorParcela7x })
        parcelas.push({ value: 8, text: `8x de R$ ${valorParcela8x}`, currency: valorParcela8x })
        parcelas.push({ value: 9, text: `9x de R$ ${valorParcela9x}`, currency: valorParcela9x })
        parcelas.push({ value: 10, text: `10x de R$ ${valorParcela10x}`, currency: valorParcela10x })
      }

      return parcelas
    }
  },

  watch: {
    'customer.first_name' () {
      this.customer.description = this.customer.first_name + ' ' + this.customer.last_name
    },

    'customer.last_name' () {
      this.customer.description = this.customer.first_name + ' ' + this.customer.last_name
    }
  },

  methods: {
    loadPedido (id) {
      this.$store.dispatch('getPedido', id)
        .then(pedido => {
          this.pedido = pedido
          if (this.pedido.exames) {
            this.subTotalDrAchei = this.pedido.exames.map(exame => exame.valorDrAchei).reduce((a, value) => a + value, 0)
            this.subTotalSinSaude = this.pedido.exames.map(exame => exame.valorSinSaude).reduce((a, value) => a + value, 0)
            this.subTotalParticular = this.pedido.exames.map(exame => exame.valorParticular).reduce((a, value) => a + value, 0)
          }
        })
    },
    async pagarComBoleto () {
      try {
        this.$store.dispatch('setLoading', true)

        const id = this.$route.query.id

        const paymentPayload = {
          'dia_pagamento': this.dia_pagamento,
          'pedido_id': id
        }

        const response = await this.$store.dispatch('comprarServicoComBoleto', paymentPayload)
        const pedido = await this.$store.dispatch('getPedido', id)
        pedido.statusPagamento = 'AGUARDANDO_PAGAMENTO'
        pedido.linkBoleto = response.data.payment_method.url
        if (this.dependente) {
          pedido.dependente = this.dependente
        }
        await this.$store.dispatch('updatePedido', pedido)

        this.$store.dispatch('showSuccessMsg', { body: 'Compra realizada com sucesso' })

        this.$router.push({name: 'Voucher', query: {id}})
      } catch (error) {
        console.log(error.message)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async pagarComCredito () {
      try {
        this.$store.dispatch('setLoading', true)

        if (this.isCardValid) {
          const paymentPayload = {
            pedido_id: this.$route.query.id,
            card: this.card,
            installment_plan: this.installment_plan
          }

          await this.$store.dispatch('comprarServicoComCredito', paymentPayload)
          this.$store.dispatch('showSuccessMsg', { body: 'Compra realizada com sucesso' })
          this.payment(false)
        } else {
          this.$store.dispatch('showPaymentErrorMsg', 'Cartão de crédito com informações incompletas ou inválidas')
        }
      } catch (error) {
        console.log(error.message)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    getValor (exame) {
      return exame.valorParticular
    },

    payment (pagamentoAto) {
      let id = this.$route.query.id
      this.$store.dispatch('getPedido', id)
        .then(pedido => {
          pedido.pagamentoAto = pagamentoAto
          if (this.dependente) {
            pedido.dependente = this.dependente
          }
          this.$store.dispatch('updatePedido', pedido)
            .then(pedido => {
              if (!pedido.agendamento) {
                this.$router.push({name: 'Voucher', query: {id}})
              } else {
                let agendamento = {}
                agendamento.rede = pedido.consulta.rede
                agendamento.especialidade = pedido.consulta.especialidade._id
                agendamento.corpoClinico = pedido.profissional
                agendamento.agenda = pedido.agendamento.agenda
                agendamento.user = pedido.cliente
                agendamento.dataEscolhida = pedido.agendamento.dataEscolhida
                agendamento.horarioEscolhido = pedido.agendamento.horarioEscolhido.horario
                this.$store.dispatch('saveAgendamento', agendamento)
                  .then(agendamento => {
                    this.$router.push({name: 'Voucher', query: {id}})
                  })
              }
            })
        })
    },

    async aplicarCupom () {
      const resultValidation = await this.$validator.validateAll()
      if (resultValidation) {
        const payload = {
          idPedido: this.pedido._id,
          cupom: this.cupom
        }
        await this.$store.dispatch('aplicarCupom', payload)
        this.loadPedido(this.pedido._id)
      }
    }
  },

  mounted () {
    var $sticky = window.jQuery('.sticky')
    var $stickyrStopper = window.jQuery('.sticky-stopper')
    if ($sticky.offset()) { // make sure ".sticky" element exists
      var generalSidebarHeight = $sticky.innerHeight()
      var stickyTop = $sticky.offset().top
      var stickOffset = 0
      var stickyStopperPosition = $stickyrStopper.offset().top
      var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset
      var diff = stopPoint + stickOffset

      window.jQuery(window).scroll(function () { // scroll event
        var windowTop = window.jQuery(window).scrollTop() // returns number
        if (stopPoint < windowTop) {
          $sticky.css({ position: 'absolute', top: diff })
        } else if (stickyTop < windowTop + stickOffset) {
          $sticky.css({ position: 'fixed', top: stickOffset })
        } else {
          $sticky.css({position: 'absolute', top: 'initial'})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/pagamentos/Checkout.vue